import React, { Component } from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';

import { handleResetPassword, updateField } from '~/Redux/Modules/Auth';

import Button from '~/Components/Global/Form/Button';
import Card from '~/Components/Layout/Card/Card';
import Form from '~/Components/Global/Form/Form';
import TextInput from '~/Components/Global/Form/TextInput';

class RequestPasswordReset extends Component {
  componentDidUpdate() {
    const { match, updateField, current } = this.props;
    if (match.params.token !== current.token) updateField({ token: match.params.token });
  }

  componentDidMount() {
    const { match, updateField, current } = this.props;
    if (match.params.token !== current.token) updateField({ token: match.params.token });
  }

  render() {
    const { handleResetPassword, updateField, current, isFetching } = this.props;
    return (
      <Card>
        <Form handleSubmit={() => handleResetPassword({ current })}>
          <TextInput
            className="minimal-input mobile-font-fix"
            onChange={updateField}
            placeholder="Email address"
            name="email"
            showLabel={false}
            type="email"
            value={current.email}
          />
          <TextInput
            className="minimal-input mobile-font-fix"
            onChange={updateField}
            placeholder="Password"
            name="password"
            showLabel={false}
            type="password"
            value={current.password}
          />
          <TextInput
            className="minimal-input mobile-font-fix margin-bottom"
            onChange={updateField}
            placeholder="Confirm password"
            name="password_confirmation"
            showLabel={false}
            type="password"
            value={current.password_confirmation}
          />
          <div className="center margin-top">
            <Button
              type="submit"
              text="UPDATE PASSWORD"
              actionText="Requesting"
              isFetching={isFetching}
              disabled={isFetching}
              className="btn btn-default pill"
            />
          </div>
        </Form>
      </Card>
    );
  }
}

RequestPasswordReset.propTypes = {
  handleLogin: propTypes.func,
  updateField: propTypes.func,
  current: propTypes.object,
  isFetching: propTypes.bool,
  match: propTypes.object,
  handleResetPassword: propTypes.func,
};

RequestPasswordReset.defaultProps = {
  isAuthenticated: false,
  isFetching: false,
  hasFetched: false,
};

const mapStateToProps = ({ Auth }) => {
  return {
    isAuthenticated: Auth.isAuthenticated,
    isFetching: Auth.isLogging,
    hasFetched: Auth.hasFetched,
    current: Auth.current,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    handleResetPassword: data => {
      return dispatch(handleResetPassword(data));
    },
    updateField: data => {
      return dispatch(updateField(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RequestPasswordReset);
